module.exports = __webpack_public_path__ + "img/Steor-Icons-08.c8e1f4fc.svg";